var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.price)+" "),(_vm.currency)?_c('span',{staticClass:"text-gray-600 uppercase"},[_vm._v(_vm._s(_vm.currency))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }